<template lang="pug">
div.collapse-setting(:class="open ? 'opening': ''")
	div.collapse-title(@click="handleClick" )
		div.arrow
		div.title(:class="open ? 'text-b': ''") {{ title }}
		div.check-icon(:class="checkedClass")
	div.collapse-body(v-if="open")
		slot
</template>

<script>
	export default {
		name: "GlobalCollapseSetting",
		props: {
			title:{
				type: String
			},
			name:{
				type: String
			},
			open: {
				type: Boolean,
				default: false
			},

			selected: {
				type: Object
			},

			group:{
				type: Array
			},

			checked: {
				type: Boolean
			}
		},

		data() {
			return {
				openStatus: false
			}
		},
        watch: {
		  open() {
		    if (!this.collapse_status.value[this.name]) this.collapse_status.value[this.name] = 1;
          }
        },
		
		mounted(){
			if (this.checked) this.collapse_status.value[this.name] = 1;
		},

		computed:{
			checkedClass() {
				if (this.checked) return "checked-icon";

				if (nse_config.product_info.cart_item_key.length > 0) return "checked-icon";

				var checked = true;

				if (!(this.collapse_status.value[this.name] >= 1)){
				    return 'no-checked'
                }

                this.group.map(section => {
                    if (section.type !== 'image-select-checkbox') {
                        if (!section.type) {
                            section.options.map(opt => {
                                if (!this.selected[opt.name]) {
                                    checked = false;
                                }
                            });
                        } else {
                            if (section.show !== 'hidden' && !this.selected[section.name] && section.type !== 'product-detail') {
                                checked = false;
                            }
                        }
                    }
                });
				return checked ? 'checked-icon' : 'no-checked'
			}
		},
		methods: {
			handleClick() {
				// this.openStatus = !this.openStatus;
				if(!this.open) {
					this.$emit('tabOpen', this.name);
				} else {
					this.$emit('tabClose', this.name);
				}
			}
		}
	}
</script>

<style lang="scss">
	.collapse-setting {
		.collapse-title {
			padding: 0;
			background-color: #fff;
			cursor: pointer;
			display: flex;
			align-content: center;
			align-items: center;
			.arrow {
				width: 30px;
				background-image: var(--asset-arrow-right-svg, url("/assets/image/arrow-right.svg"));
				min-height: 30px;
				background-repeat: no-repeat;
				background-position: center;
				transition: all 0.12s;
			}
			.title {
				flex-grow: 1;
				padding: 15px 5px;
				text-transform: uppercase;
				user-select: none;
			}

			.check-icon {
				width: 30px;
				min-height: 30px;
				margin-right: 10px;
				background-image: var(--asset-checked-svg, url("/assets/image/icon/image-checked.svg"));
				background-repeat: no-repeat;
				background-position: center center;
				&.no-checked {
					background-image: var(--asset-unchecked-svg, url("/assets/image/icon/image-uncheck.svg"));
				}
			}
		}
		.collapse-body {
			background-color: #F9FAFB;
			padding: 15px;
			padding-bottom: 0;

			.nse-form-group{
				&:last-child {
					padding-bottom: 15px;
				}
			}
		}

		&.opening {
			.arrow {
				transform: rotate(90deg);
			}
			.collapse-body {
				border-top: 1px solid #f1f1f1;
			}
		}

	}
</style>
